<script>
export default {
  name: "vc-share-text-contains-link",
  render(createElement) {
    return createElement(
      "span",
      this.getReplacedAsLinkElements(this.$slots.default, createElement)
    );
  },
  props: {
    replace: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getReplacedAsLinkElements(elements, createElement) {
      let retElements = [];

      elements.forEach(node => {
        if (node.children) {
          retElements.push(
            createElement(
              node.tag,
              node.data,
              this.getReplacedAsLinkElements(node.children, createElement)
            )
          );
        } else if (node.text) {
          let texts = [node.text];

          Object.keys(this.replace).forEach(key => {
            let tmpTexts = [];
            texts.forEach(text => {
              if (typeof text === "string") {
                const splitedTexts = text.split(
                  new RegExp("(" + this.escapeRegExpString(key) + ")")
                );
                splitedTexts.forEach(splitedText => {
                  if (splitedText == key) {
                    tmpTexts.push(
                      createElement(
                        "vc-share-a",
                        { props: { ...this.replace[key] } },
                        this.replace[key].text
                      )
                    );
                  } else {
                    tmpTexts.push(splitedText);
                  }
                });
              } else {
                tmpTexts.push(text);
              }
            });

            texts = tmpTexts;
          });

          texts.forEach(text => {
            retElements.push(text);
          });
        } else {
          retElements.push(node);
        }
      });

      return retElements;
    },
    escapeRegExpString(val) {
      return val.replace(/([\\*+.?{}()[\]^$\-|])/g, "\\$&");
    }
  }
};
</script>
